<template>
  <v-dialog :value="true" max-width="290">
    <v-card>
      <v-card-title class="headline">Editar Joined</v-card-title>
      <v-card-text class="pt-4">
        <v-alert type="error" v-if="errorMessage" class="mb-6">{{ errorMessage }}</v-alert>
        <v-form ref="form" @submit.prevent>
          <decimal-number
            v-if="type === 'goal' || type === 'addToGoal'"
            :label="type === 'goal' ? 'Nova meta' : 'Valor para adicionar'"
            v-model="fields.amount.value"
            :rules="[...fields.amount.rules]"
            outlined dense
          ></decimal-number>
          <v-text-field
            v-if="type === 'installment'"
            label="Número de parcelas"
            v-model="fields.number_of_installment.value"
            :rules="[...fields.number_of_installment.rules]"
            type="number"
            outlined dense
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="default" :disabled="saving" text @click="$emit('canceled')">
          Cancelar
        </v-btn>
        <v-btn color="success" :disabled="saving" :loading="saving" text @click="saveItems()">
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'
import DecimalNumber from '@/components/DecimalNumber'

export default {
  name: 'editJoined',
  components: {
    DecimalNumber
  },
  props: {
    type: {
      required: true,
      type: String
    },
    items: {
      required: true,
      type: Array
    }
  },
  data: () => ({
    saving: false,
    fields: {
      amount: {
        value: '',
        rules: [
          v => !!v || 'O valor é obrigatório'
        ]
      },
      number_of_installment: {
        value: 0,
        rules: [
          v => (!!v || v === 0) || 'O número de parcelas é obrigatório'
        ]
      }
    },
    errorMessage: null
  }),
  computed: {
    //
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    async saveItems () {
      this.saving = true

      try {
        for (const index in this.items) {
          const item = this.items[index]
          let data = {}
          if (this.type === 'installment') {
            data.number_of_installment = this.fields.number_of_installment.value || 0
          } else if (this.type === 'goal') {
            data.amount_to_pay = this.fields.amount.value || 0
          } else {
            if (item && this.fields.amount.value) data.amount_to_pay = this.fields.amount.value + item.amount_to_pay
          }
          await axios('joineds/' + item.joined_id, { method: 'patch', data })
        }
        this.saving = false
        this.SET_SNACKBAR({ text: 'Joineds atualizados' })
        this.$emit('edited')
      } catch (error) {
        this.errorMessage = 'Houve um erro ao processar seu pedido, por favor atualize a página e tente novamente'
        this.sending = false
      }
    }
  },
  created () {
    if (!this.items || this.items.length === 0) {
      this.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
      this.$emit('error')
    }
  }
}
</script>
